import React from "react";
import PropTypes from "prop-types";
import { BOOKING_URL } from "../../config/booking";

const BookingLink = ({ children, className, showExternalIcon }) => (
  <a
    className={className}
    href={BOOKING_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className="booking-link-content">
      {children}
      {showExternalIcon && (
        <i
          className="fas fa-external-link-alt booking-link-icon"
          aria-hidden="true"
        />
      )}
      <span className="sr-only"> (ouvre un nouvel onglet)</span>
    </span>
  </a>
);

BookingLink.defaultProps = {
  children: "Prendre rendez-vous sur Planity",
  className: "",
  showExternalIcon: false,
};

BookingLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  showExternalIcon: PropTypes.bool,
};

export default BookingLink;
